import { format } from 'owa-string-utils';
import { DatapointStatus, GenericKeys } from '../types/DatapointEnums';
import { isClientVerboseQueryStringEnabled } from './AriaDatapoint';
import { PerformanceDatapoint } from './PerformanceDatapoint';
import { trace, TraceErrorObject } from 'owa-trace';
import RequestOptions from 'owa-service/lib/RequestOptions';

export class ActionDatapoint extends PerformanceDatapoint {
    private allRequestIds: string[] = [];
    private responseCorrelationVectors: string[] = [];
    private madeNetworkRequest = false;
    endAction(overrideStatus?: DatapointStatus, error?: TraceErrorObject): void {
        this.addData(GenericKeys.requestIds, this.allRequestIds.join(';'));
        this.addData(GenericKeys.correlationVectors, this.responseCorrelationVectors.join(';'));
        this.addData(GenericKeys.cache, this.madeNetworkRequest ? 'Cache' : 'NoCache');
        this.end(undefined, overrideStatus, error);
    }
    trackNetworkResponse(
        responsePromise: Promise<Response>,
        action: string,
        options: RequestOptions
    ) {
        this.addCheckpoint(action + '_sr_s');
        responsePromise.then(
            (response: Response) => {
                this.collectResponseDiagnostics(action, options, response);
            },
            () => {
                this.collectResponseDiagnostics(action, options);
            }
        );
    }
    private collectResponseDiagnostics(
        action: string,
        options: RequestOptions,
        response?: Response
    ) {
        if (this.hasEnded) {
            trace.warn(
                format(
                    'Service Request:{0} was not captured in your datapoint({1})',
                    action,
                    this.eventName
                )
            );
            return;
        }

        this.madeNetworkRequest = true;
        this.addCheckpoint(action + '_sr_e');

        if (response?.headers) {
            const requestId = response.headers.get('request-id');
            if (requestId) {
                this.allRequestIds.push(requestId);
            }

            if (isClientVerboseQueryStringEnabled()) {
                this.addCustomProperty(action + '_status', response.status);
                if (response.status !== 200) {
                    this.addCustomProperty(action + '_AFD', response.headers.get('x-msedge-ref'));
                }
            }
        }
        if (options?.headers) {
            const cv = options.headers.get('ms-cv');
            if (cv) {
                this.responseCorrelationVectors.push(cv);
            }
        }
    }
}
